import { MessageBox, Message, Notification } from 'element-ui'
import i18n from './config/i18n'

import dottie from 'dottie'

export default {
  install(Vue) {
    Vue.prototype.$msgbox = MessageBox
    Vue.prototype.$alert = MessageBox.alert
    Vue.prototype.$confirm = MessageBox.confirm
    Vue.prototype.$prompt = MessageBox.prompt

    // Vue.prototype.$loading = Loading.service
    Vue.prototype.$notify = Notification
    Vue.prototype.$message = Message

    Vue.prototype.$success = message => {
      Message({
        message: message || 'All fine...',
        type: 'success',
        duration: 1500
      })
    }

    Vue.prototype.$notifySuccess = (message) => {
      Notification({
        title: 'Success',
        message: message || 'Data saved successfully',
        type: 'success'
      })
    }

    Vue.prototype.$notifyError = (error) => {
      let title, message, locale
      if (!error) {
        title = 'info.errors.standard.title'
        message = 'info.errors.standard.message'
        locale = 'en'
      } else {
        title = error.title
        message = error.message
        locale = error.locale || 'en'
      }

      const h = new Vue().$createElement
      const m = h('div', { class: 'content' }, [ h('p', {}, dottie.get(i18n.messages[locale], message)) ])

      Notification({
        title: dottie.get(i18n.messages[locale], title),
        message: m,
        type: 'error'
      })
    }

    Vue.prototype.$notifySuccessDeleted = ({ titleKey, messageKey, locale, duration }) => {
      if (titleKey && messageKey && locale) {
        return Notification({
          title: dottie.get(i18n.messages[locale], titleKey),
          message: dottie.get(i18n.messages[locale], messageKey),
          type: 'success',
          duration: duration || 4500
        })
      }
      Notification({
        title: 'Success',
        message: 'Data deleted successfully',
        type: 'success'
      })
    }

    Vue.prototype.$notifyActiveRewards = (activeRewards, locale = 'en') => {
      const title = dottie.get(i18n.messages[locale], 'account.delete.activeRewardNotification.title')
      const heading = dottie.get(i18n.messages[locale], 'account.delete.activeRewardNotification.heading')
      const text = dottie.get(i18n.messages[locale], 'account.delete.activeRewardNotification.message')
      const h = new Vue().$createElement
      const rewards = activeRewards.map(r => h('li', [
        h('a', { attrs: { href: `/myprofile/rewards/edit/${r._id}` } }, `- ${r.name}`)
      ]))
      const message = h('div', [
        h('h1', { class: { 'warn-h1': true }, style: { 'text-align': 'left' } }, heading),
        h('p', { style: { 'text-align': 'left' } }, `${text}:`),
        h('ul', { class: { 'warn-ul': true } }, rewards)
      ])
      Notification({
        title: title,
        message: message,
        type: 'error'
      })
    }

    Vue.prototype.$notifyActivePledges = (activePledges, locale = 'en') => {
      const title = dottie.get(i18n.messages[locale], 'account.delete.activePledgeNotification.title')
      const heading = dottie.get(i18n.messages[locale], 'account.delete.activePledgeNotification.heading')
      const text = dottie.get(i18n.messages[locale], 'account.delete.activePledgeNotification.message')

      const h = new Vue().$createElement
      const pledges = activePledges.map(p => h('li', [
        h('a', { attrs: { href: `/myprofile/purchases/edit/reward/${p._id}` } }, `- ${p.rewardName}`)
      ]))
      const message = h('div', [
        h('h1', { class: { 'warn-h1': true }, style: { 'text-align': 'left' } }, heading),
        h('p', { style: { 'text-align': 'left' } }, `${text}:`),
        h('ul', { class: { 'warn-ul': true } }, pledges)
      ])
      Notification({
        title: title,
        message: message,
        type: 'error'
      })
    }

    Vue.prototype.$confirmAccountDeletion = methodOptions => {
      const user = methodOptions.user
      const translation = i18n.messages[methodOptions.locale].account.delete.confirmation
      const h = new Vue().$createElement

      const title = translation.goodbye
      let content
      if (user.artist) {
        content = h('p', translation.artist.when)
      } else {
        content = h('p', translation.fan.when)
      }

      const message = h('div', [
        h('p', `${translation.greeting} ${user.nickname},`),
        h('p', translation.honey),
        content
      ])

      return MessageBox.confirm(
        message,
        title,
        {
          confirmButtonText: 'Delete Account',
          cancelButtonText: 'Cancel',
          type: 'error'
        }
      ).catch(e => {})
    }

    Vue.prototype.$confirmDelete = methodOptions => {
      const defaults = {
        message: 'This will permanently delete this item. Proceed anyway?',
        title: 'Danger'
      }
      const options = Object.assign({}, defaults, methodOptions)
      return MessageBox.confirm(
        options.message,
        options.title,
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'error',
          dangerouslyUseHTMLString: options.dangerouslyUseHTMLString
        }
      ).catch(e => {})
    }

    Vue.prototype.$confirmSave = methodOptions => {
      const defaults = {
        message: 'Please confirm to save of your data',
        title: 'Save your data'
      }
      const options = Object.assign({}, defaults, methodOptions)
      return MessageBox.confirm(
        options.message,
        options.title,
        {
          confirmButtonText: 'Save',
          cancelButtonText: 'Cancel',
          type: 'info'
        }
      ).catch(e => {})
    }

    Vue.prototype.$confirmUnsaved = () => {
      return MessageBox.confirm(
        i18n.messages[i18n.locale].confirm.unsaved.message,
        i18n.messages[i18n.locale].confirm.unsaved.title,
        {
          confirmButtonText: i18n.messages[i18n.locale].confirm.unsaved.ok,
          cancelButtonText: i18n.messages[i18n.locale].confirm.unsaved.cancel,
          type: 'warning'
        }
      ).catch(e => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/dialogues.js